module.exports = __webpack_public_path__ + "static/media/22792433_1629551390453379_6274377066383415936_o.54e28cdf.jpg";